import { render, staticRenderFns } from "./XFooter.vue?vue&type=template&id=7404616d&"
import script from "./XFooter.vue?vue&type=script&lang=js&"
export * from "./XFooter.vue?vue&type=script&lang=js&"
import style0 from "./XFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports